// Port de Leyro EmailVerificationBanner adaptado a chain
// (`user.email_verified` snake_case + endpoint /api/v1/auth/resend-verification).

import { Mail, X } from 'lucide-react';
import { useState } from 'react';

import { resendVerification } from '../../api/auth';
import { describeAxiosError } from '../../api/errors';
import { useAuthContext } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';

const STORAGE_KEY = 'chain:emailBannerDismissed';

export default function EmailVerificationBanner() {
  const { user } = useAuthContext();
  const { addToast } = useToast();
  const [sending, setSending] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (!user || user.email_verified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await resendVerification({ email: user.email });
      addToast('Reenviámosche o correo de verificación.', 'success');
    } catch (err) {
      addToast(describeAxiosError(err, 'Non se puido reenviar o correo.'), 'error');
    } finally {
      setSending(false);
    }
  };

  const handleDismiss = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3 text-sm">
        <Mail size={16} className="text-yellow-700 shrink-0" />
        <div className="flex-1 min-w-0">
          <span className="text-yellow-900 font-medium">Verifica o teu enderezo de email.</span>{' '}
          <span className="text-yellow-800 hidden sm:inline">
            Enviamos un link a <strong>{user.email}</strong>; fai clic nel para activar todas as
            funcionalidades.
          </span>
        </div>
        <button
          onClick={handleResend}
          disabled={sending}
          className="shrink-0 px-3 py-1 rounded-lg bg-yellow-700 text-white text-xs font-semibold hover:bg-yellow-800 transition-colors disabled:opacity-50"
        >
          {sending ? 'Enviando…' : 'Reenviar'}
        </button>
        <button
          onClick={handleDismiss}
          className="shrink-0 p-1 text-yellow-700 hover:text-yellow-900 transition-colors"
          aria-label="Ocultar aviso"
          title="Ocultar"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
